import { createContext, useContext, useEffect, useState } from "react";
import { useUI } from "./UIContext";
import { get, getBlob } from "./services/api";
import { handleErr } from "./utils/functions";
import { Theme } from "./constants/theme";

const UserContext = createContext();

export function UserProvider({ children }) {
    const { setLoading, setMessage, setBackgroundImg, userTheme, setUserTheme, effectiveTheme } = useUI();
    const [user, setUser] = useState(undefined);
    const [photo, setPhoto] = useState(undefined);

    useEffect(() => {
        async function getUserTheme() {
            await get('/user-config/theme', true, setMessage,
                (response) => {
                    const theme = response?.data?.theme;

                    if (theme === Theme.LIGHT || theme === Theme.DARK || theme === Theme.SYSTEM) {
                        setUserTheme(theme);
                        return;
                    }

                    setUserTheme(Theme.LIGHT);
                },
                (err) => {
                    handleErr(setMessage, `Não foi possível recuperar o tema do utilizador: ${err}`);
                    setUserTheme(Theme.LIGHT);
                },
                () => {},
            );
        }

        getUserTheme();
    }, [setMessage, setUserTheme]);

    useEffect(() => {
        if (!userTheme || !effectiveTheme) {
            return;
        }

        async function getBackgroundImg() {
            setLoading(true);

            await getBlob('config/background-image', true, setMessage,
                (response) => {
                    setBackgroundImg(response.data);
                },
                (err) => {
                    handleErr(setMessage, `Não foi possível recuperar a imagem de fundo: ${err}`);
                },
                () => {
                    setLoading(false);
                },
                { theme: effectiveTheme },
                () => {
                    setBackgroundImg(undefined);
                }
            );
        }

        getBackgroundImg();
    }, [effectiveTheme, setBackgroundImg, setLoading, setMessage, userTheme]);

    useEffect(() => {

        async function getUserPhoto() {
            await getBlob('/user/photo', true, setMessage,
                (response) => {
                    setPhoto(response.data);
                },
                (err) => {
                    handleErr(setMessage, `Falha ao carregar a foto do utilizador: ${err}`);
                },
                () => {
                    setLoading(false);
                }
            );
        }

        async function getUserData() {
            setLoading(true);

            let userData;

            await get('/user', true, setMessage,
                async (response) => {
                    setUser(response.data);
                    userData = response.data;

                    if (!userData.photoPath) {
                        setLoading(false);
                        return;
                    }

                    await getUserPhoto();
                },
                (err) => {
                    handleErr(setMessage, `Falha ao acessar a conta: ${err}`);
                },
                () => {
                    if (!userData?.photoPath) {
                        setLoading(false);
                    }
                }
            );
        }

        getUserData();
    }, [setLoading, setMessage]);
    
    return (
        <UserContext.Provider value={{ user, photo }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    return useContext(UserContext);
}